import React from 'react';
import IEditorStructure from '@start-set/wakadoo-editor-core/IEditorStructure';
import { VisualizerEditor } from '@start-set/wakadoo-editor-core';
import css from '../../styles/editor.module.scss';

export interface ComponentOfferPresentingProps {
	structure: IEditorStructure,
}

export class ComponentOfferPresetting extends React.Component<ComponentOfferPresentingProps, object> {
	private editor: VisualizerEditor | null = null;
	private ref : React.RefObject<HTMLDivElement>;

	constructor(props: ComponentOfferPresentingProps | Readonly<ComponentOfferPresentingProps>) {
		super(props);
		const { structure } = this.props;
		this.state = structure;
		this.ref = React.createRef();
	}

	override componentDidMount() {
		this.createManipulator();
	}

	override componentDidUpdate(
		prevProps: ComponentOfferPresentingProps | Readonly<ComponentOfferPresentingProps>,
	) {
		const { structure } = this.props;
		if (prevProps.structure.root.components !== structure.root.components) {
			this.updateRef();
			const container = this.ref.current;
			if (container === null || container === undefined) {
				throw new Error('manipulator container not found');
			}

			this.editor = new VisualizerEditor({
				isEnableMouseWheel: false,
				editorContainer: container,
				isCanvasHeightAdaptive: true,
				imageFileSourcePrefix: '/api/file/user'
			});
			this.editor.setStructure(structure);
		}
	}

	override componentWillUnmount() {
		if (this.editor === null) {
			return;
		}
		this.editor.destruct();
	}

	private createManipulator = () => {
		const { structure } = this.props;
		if (!this.ref) return;
		const container = this.ref.current;
		if (container === null || container === undefined) {
			throw new Error('manipulator container not found');
		}

		this.editor = new VisualizerEditor({
			isEnableMouseWheel: false,
			editorContainer: container,
			isCanvasHeightAdaptive: true,
			imageFileSourcePrefix: '/api/file/user'
		});
		this.editor.setStructure(structure);
	};

	updateRef() {
		if (this.ref.current) {
			this.ref.current.innerHTML = '';
		}
	}

	override render() {
		return <div ref={this.ref} className={`${css.editor} ${css.offer_presetting}`} />;
	}
}
